import React from 'react';
import SelectableCard, { SelectableCardContext, SelectableCardProps } from '../SelectableCard';
import { CollectionGribble } from '../../Collection/model';

export function SelectableCardGribble(props: SelectableCardProps<unknown>) {
  return (
    <SelectableCard {...props}>
      <SelectableCard.Image alt="Gribble">
        <SelectableCard.CornerImage alt="Paired Breaker" />
      </SelectableCard.Image>
      <SelectableCard.Body>
        <SelectableCard.Title />
      </SelectableCard.Body>
    </SelectableCard>
  );
}

SelectableCardGribble.transformer = (
  gribble: CollectionGribble,
): SelectableCardContext<CollectionGribble> => {
  return {
    title: `Gribble #${gribble.id}`,
    image: gribble.image?.thumbnail,
    ctx: gribble,
    cornerImage: gribble.pairedBreaker?.breakerSrc,
  };
};
